export const API_MEWS_URL = "https://www.mysharingsystem.com/api/"; 
//export const API_MEWS_URL = 'https://localhost:7142/api/';